import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle
} from '@ui/dialog.tsx';
import { useTranslation } from 'react-i18next';
import type { FC } from 'react';
import { TrendingUp } from 'lucide-react';
import type { BoosterDraftData } from './create-booster-form-schema.ts';
import { SelectBoosterReferencesStep } from './select-booster-references-step.tsx';
import type { BoosterReferencesSelectionState } from './booster-references-selection.ts';

interface SelectBoosterReferencesDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  draft: BoosterDraftData | null;
  onBack: () => void;
  onSuccess?: () => void;
  referencesSelection: BoosterReferencesSelectionState;
  onReferencesSelectionChange: (state: BoosterReferencesSelectionState) => void;
}

/** Modale étape 2 : sélection des références produits éligibles au booster. */
export const SelectBoosterReferencesDialog: FC<SelectBoosterReferencesDialogProps> = ({
  isOpen,
  onOpenChange,
  draft,
  onBack,
  onSuccess,
  referencesSelection,
  onReferencesSelectionChange
}) => {
  const { t } = useTranslation();

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent
        className="max-w-6xl overflow-hidden p-0"
        onOpenAutoFocus={(event) => event.preventDefault()}
      >
        <div className="scrollable max-h-[90vh] overflow-y-auto p-10">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2.5 text-2xl">
              <TrendingUp className="h-6 w-6" />
              {draft
                ? t('boosters.create.references.title.with.name', { title: draft.title })
                : t('boosters.create.references.title')}
            </DialogTitle>
            <DialogDescription>{t('boosters.create.references.subtitle')}</DialogDescription>
          </DialogHeader>

          <div className="mt-6">
            {draft && isOpen && (
              <SelectBoosterReferencesStep
                key={`${draft.title}-${draft.coefficient}-${draft.startDate.toISOString()}-${draft.endDate.toISOString()}`}
                draft={draft}
                referencesSelection={referencesSelection}
                onReferencesSelectionChange={onReferencesSelectionChange}
                onBack={onBack}
                onSuccess={() => {
                  onOpenChange(false);
                  onSuccess?.();
                }}
              />
            )}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
